import { SectionScrollerReturn, WayPointInteractionParams, ScrollParams } from '@fiverr-private/gig_page_types';
import { ABOUT_EXPERT, OVERVIEW, TOP_PAGE } from '../../constants';
import { scrollToComponent } from '../scrollToComponent/scrollToComponent';
import {
    SCROLL_DURATION,
    SCROLL_OFFSET,
    BUSINESS_SCROLL_OFFSET,
    WAYPOINT_OFFSET,
} from '../../components/Waypoint/Waypoint.constants';

export function sectionScroller(): SectionScrollerReturn {
    let currentSection = OVERVIEW;
    let useWaypoints = true;
    const refsObj: Record<string, Element> = {};

    const scroll = ({ sectionKey, forceScroll }: ScrollParams) => {
        const ref = refsObj[sectionKey];

        if (ref && (sectionKey !== currentSection || forceScroll)) {
            const nextSectionKey = sectionKey === ABOUT_EXPERT ? TOP_PAGE : sectionKey;
            const scrollOffset = sectionKey === ABOUT_EXPERT ? BUSINESS_SCROLL_OFFSET : SCROLL_OFFSET;

            currentSection = nextSectionKey;
            useWaypoints = false;

            const scroller = scrollToComponent(ref, {
                offset: scrollOffset,
                align: 'top',
                duration: SCROLL_DURATION,
            });

            // we need a timeout here, otherwise the waypoints fire
            // right at the end of the scroll
            scroller.onComplete(() => {
                setTimeout(() => {
                    useWaypoints = true;
                }, 50);
            });
        }
    };

    const onEnterWaypoint = ({ section, data }: WayPointInteractionParams) => {
        if (!section || !useWaypoints) {
            return;
        }

        const scrollingUp = data.currentPosition === 'inside' && data.previousPosition === 'above';

        if (section !== currentSection && scrollingUp) {
            currentSection = section;
        }
    };

    const onLeaveWaypoint = ({ section, data }: WayPointInteractionParams) => {
        if (!section || !useWaypoints) {
            return;
        }

        if (section !== currentSection) {
            if (data.waypointTop < WAYPOINT_OFFSET) {
                currentSection = section;
            }
        }
    };

    return {
        currentSection,
        refsObj,
        scroll,
        onEnterWaypoint,
        onLeaveWaypoint,
    };
}
